<div class="welcome" [class.uat]="is_uat">
    <div class="body">
        <div class="image-wrapper">
            <img class="main" src="assets/img/welcome.jpg" />
            <div class="app-name"><span>my</span>VirtualCare</div>
        </div>
        <div class="container">
            <div class="card-wrapper">
                <div class="card">
                    <div class="header">
                        <img src="assets/img/nsw_gov_logo.svg" />
                    </div>
                    <div class="card-body" *ngIf="form && !error; else error_state">
                        <ng-container *ngIf="!loading; else load_state">
                            <div class="title">
                                <div>Join {{ waiting_room?.name }}</div>
                                <div class="subtitle">Please fill out below</div>
                            </div>
                            <form class="form" [formGroup]="form">
                                <div class="field">
                                    <label for="name">Full Name <span>*</span></label>
                                    <mat-form-field appearance="outline">
                                        <input
                                            type="text"
                                            matInput
                                            formControlName="name"
                                            [placeholder]="'Full name here...'"
                                        />
                                    </mat-form-field>
                                </div>
                                <div class="field">
                                    <label for="phone">Phone (optional)</label>
                                    <mat-form-field appearance="outline">
                                        <input
                                            matInput
                                            type="text"
                                            formControlName="phone"
                                            onlyNumber
                                            [placeholder]="'Phone number here...'"
                                        />
                                    </mat-form-field>
                                </div>
                                <div>
                                    <label for="role">I am <span>*</span></label>
                                    <mat-form-field appearance="outline">
                                        <mat-select
                                            formControlName="role"
                                            placeholder="Please select your role"
                                        >
                                            <mat-option
                                                *ngFor="let role of role_options"
                                                [value]="role"
                                            >
                                                {{ role.name }}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="button">
                                    <button
                                        mat-button
                                        class="green dark-text"
                                        name="welcome"
                                        [disabled]="!form.valid"
                                        (tapped)="submit()"
                                    >
                                        Next
                                    </button>
                                </div>
                            </form>
                        </ng-container>
                    </div>
                    <div class="card-footer">If your call is an emergency, dial 000</div>
                </div>
            </div>
            <!-- <div class="footer">
                <a [href]="waiting_room?.help_button" target="_blank">
                    <div class="text">Help</div>
                    <div class="icon">
                        <i class="material-icons">help</i>
                    </div>
                </a>
                <div class="line"></div>
                <a [href]="welcome_video" target="_blank">
                    <div class="text">Instructional Video</div>
                    <div class="icon">
                        <i class="material-icons">video_library</i>
                    </div>
                </a>
                <div class="line"></div>
                <a href="https://www.health.nsw.gov.au/policies/manuals/Pages/privacy-manual-for-health-information.aspx" target="_blank">
                    <div class="text">Privacy</div>
                    <div class="icon">
                        <i class="material-icons">lock</i>
                    </div>
                </a>
            </div> -->
        </div>
    </div>
</div>
<ng-template #error_state>
    <ng-container [ngSwitch]="error">
        <ng-container *ngSwitchCase="'room'">
            <ng-container *ngTemplateOutlet="noRoom"></ng-container>
        </ng-container>
        <ng-container *ngSwitchCase="'session'">
            <ng-container *ngTemplateOutlet="session_expired"></ng-container>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <ng-container *ngTemplateOutlet="start_error"></ng-container>
        </ng-container>
    </ng-container>
</ng-template>
<ng-template #noRoom>
    <div class="card-body no-room">
        <p>
            An incomplete, incorrect or out-of-date web address has been entered. Please ensure the
            full web address you were sent with your appointment confirmation has been correctly
            entered into the address bar in your internet browser.
        </p>

        <p></p>
        <p>
            If you are sure the address is correctly entered but you are still seeing this message
            please contact your clinic.
        </p>
    </div>
</ng-template>
<ng-template #session_expired>
    <div class="card-body no-room">
        <p>You user session has expired!</p>
        <p>Reload the page to restart your session</p>
    </div>
</ng-template>
<ng-template #start_error>
    <div class="card-body no-room">
        <span [ngSwitch]="error">
            <ng-container *ngSwitchCase="'closed'">
                <p>This waiting room is currently closed.</p>
                <p>Please return during open hours.</p>
                <div class="hours">
                    <div
                        class="day"
                        *ngFor="let date of opening_hours"
                        [class.active]="day_of_week === date.day"
                    >
                        <div class="date">{{ date.day }}:</div>
                        <div class="time">
                            {{ date.open }} {{ date.close ? '&ndash;' : '' }} {{ date.close }}
                        </div>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngSwitchCase="'unavailable'">
                <p>The room is currently unavailable.</p>
            </ng-container>
            <ng-container *ngSwitchCase="false"></ng-container>
            <ng-container *ngSwitchDefault>
                <p>Unable to establish connection to the meeting room.</p>
                <p>Please wait a couple of minutes, reload the page and try again.</p>
            </ng-container>
        </span>
    </div>
</ng-template>
<ng-template #load_state>
    <div class="info-block">
        <mat-spinner></mat-spinner>
        <div class="text">{{ loading }}</div>
    </div>
</ng-template>
